export interface ContainexPaths {
    market: string;
    lang: string;
    urlPrefix: string;
    termsOfUsePath: string;
    privacyPolicyPath: string;
    imprintPath: string;
    inquiryPath: string;
}

export const CONTAINEX_PATHS = new Map<string, ContainexPaths[]>([
    [
        'am',
        [
            {
                market: 'am',
                lang: 'ru',
                urlPrefix: '/am/ru',
                termsOfUsePath: '/uslovija-polzovanija',
                privacyPolicyPath: '/zaschita-dannykh',
                imprintPath: '/vykhodnye-dannye',
                inquiryPath: '/formuljary/obschie-polozhenija',
            },
        ],
    ],
    [
        'at',
        [
            {
                market: 'at',
                lang: 'de',
                urlPrefix: '/at/de',
                termsOfUsePath: '/nutzungsbedingungen',
                privacyPolicyPath: '/datenschutz',
                imprintPath: '/impressum',
                inquiryPath: '/formulare/allgemein',
            },
        ],
    ],
    [
        'az',
        [
            {
                market: 'az',
                lang: 'ru',
                urlPrefix: '/az/ru',
                termsOfUsePath: '/uslovija-polzovanija',
                privacyPolicyPath: '/zaschita-dannykh',
                imprintPath: '/vykhodnye-dannye',
                inquiryPath: '/formuljary/obschie-polozhenija',
            },
        ],
    ],
    [
        'ba',
        [
            {
                market: 'ba',
                lang: 'bs',
                urlPrefix: '/ba/bs',
                termsOfUsePath: '/uslovi-koristenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opcenito',
            },
            {
                market: 'ba',
                lang: 'hr',
                urlPrefix: '/ba/hr',
                termsOfUsePath: '/uvjeti-koristenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opcenito',
            },
            {
                market: 'ba',
                lang: 'sr',
                urlPrefix: '/ba/sr',
                termsOfUsePath: '/uslovi-koriscenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opste-informacije',
            },
        ],
    ],
    [
        'be',
        [
            {
                market: 'be',
                lang: 'fr',
                urlPrefix: '/be/fr',
                termsOfUsePath: '/conditions-dutilisation',
                privacyPolicyPath: '/protection-des-donnees',
                imprintPath: '/informations-legales',
                inquiryPath: '/formulaires/generalites',
            },
            {
                market: 'be',
                lang: 'nl',
                urlPrefix: '/be/nl',
                termsOfUsePath: '/gebruiksvoorwaarden',
                privacyPolicyPath: '/privacybescherming',
                imprintPath: '/impressum',
                inquiryPath: '/formulieren/algemeen',
            },
        ],
    ],
    [
        'bg',
        [
            {
                market: 'bg',
                lang: 'bg',
                urlPrefix: '/bg/bg',
                termsOfUsePath: '/usloviia-za-polzvane',
                privacyPolicyPath: '/zashtita-na-danni',
                imprintPath: '/impresum',
                inquiryPath: '/formuliari/obshto',
            },
        ],
    ],
    [
        'ch',
        [
            {
                market: 'ch',
                lang: 'de',
                urlPrefix: '/ch/de',
                termsOfUsePath: '/nutzungsbedingungen',
                privacyPolicyPath: '/datenschutz',
                imprintPath: '/impressum',
                inquiryPath: '/formulare/allgemein',
            },
            {
                market: 'ch',
                lang: 'fr',
                urlPrefix: '/ch/fr',
                termsOfUsePath: '/conditions-dutilisation',
                privacyPolicyPath: '/protection-des-donnees',
                imprintPath: '/informations-legales',
                inquiryPath: '/formulaires/generalites',
            },
            {
                market: 'ch',
                lang: 'it',
                urlPrefix: '/ch/it',
                termsOfUsePath: '/condizioni-di-utilizzo',
                privacyPolicyPath: '/privacy',
                imprintPath: '/impressum',
                inquiryPath: '/formulari/regole-generali',
            },
        ],
    ],
    [
        'cz',
        [
            {
                market: 'cz',
                lang: 'cs',
                urlPrefix: '/cz/cs',
                termsOfUsePath: '/uzivatelske-podminky',
                privacyPolicyPath: '/ochrana-dat',
                imprintPath: '/tiraz',
                inquiryPath: '/formulare/obecne',
            },
        ],
    ],
    [
        'de',
        [
            {
                market: 'de',
                lang: 'de',
                urlPrefix: '/de/de',
                termsOfUsePath: '/nutzungsbedingungen',
                privacyPolicyPath: '/datenschutz',
                imprintPath: '/impressum',
                inquiryPath: '/formulare/allgemein',
            },
        ],
    ],
    [
        'dk',
        [
            {
                market: 'dk',
                lang: 'da',
                urlPrefix: '/dk/da',
                termsOfUsePath: '/brugsbetingelser',
                privacyPolicyPath: '/databeskyttelse',
                imprintPath: '/generel-information',
                inquiryPath: '/formularer/generelt',
            },
        ],
    ],
    [
        'ee',
        [
            {
                market: 'ee',
                lang: 'en',
                urlPrefix: '/ee/en',
                termsOfUsePath: '/terms-of-use',
                privacyPolicyPath: '/privacy-policy',
                imprintPath: '/imprint',
                inquiryPath: '/forms/general',
            },
        ],
    ],
    [
        'es',
        [
            {
                market: 'es',
                lang: 'es',
                urlPrefix: '/es/es',
                termsOfUsePath: '/condiciones-de-uso',
                privacyPolicyPath: '/proteccion-de-datos',
                imprintPath: '/aviso-legal',
                inquiryPath: '/formularios/general',
            },
        ],
    ],
    [
        'fi',
        [
            {
                market: 'fi',
                lang: 'fi',
                urlPrefix: '/fi/fi',
                termsOfUsePath: '/kaeyttoeehdot',
                privacyPolicyPath: '/tietosuoja',
                imprintPath: '/yhteystiedot',
                inquiryPath: '/lomakkeet/yleistae',
            },
        ],
    ],
    [
        'fr',
        [
            {
                market: 'fr',
                lang: 'fr',
                urlPrefix: '/fr/fr',
                termsOfUsePath: '/conditions-dutilisation',
                privacyPolicyPath: '/protection-des-donnees',
                imprintPath: '/informations-legales',
                inquiryPath: '/formulaires/generalites',
            },
        ],
    ],
    [
        'ge',
        [
            {
                market: 'ge',
                lang: 'en',
                urlPrefix: '/ge/en',
                termsOfUsePath: '/terms-of-use',
                privacyPolicyPath: '/privacy-policy',
                imprintPath: '/imprint',
                inquiryPath: '/forms/general',
            },
        ],
    ],
    [
        'hr',
        [
            {
                market: 'hr',
                lang: 'hr',
                urlPrefix: '/hr/hr',
                termsOfUsePath: '/uvjeti-koristenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opcenito',
            },
        ],
    ],
    [
        'hu',
        [
            {
                market: 'hu',
                lang: 'hu',
                urlPrefix: '/hu/hu',
                termsOfUsePath: '/felhasznalasi-feltetelek',
                privacyPolicyPath: '/adatvedelem',
                imprintPath: '/impresszum',
                inquiryPath: '/uerlap/altalanos',
            },
        ],
    ],
    [
        'ie',
        [
            {
                market: 'ie',
                lang: 'en',
                urlPrefix: '/ie/en',
                termsOfUsePath: '/terms-of-use',
                privacyPolicyPath: '/privacy-policy',
                imprintPath: '/imprint',
                inquiryPath: '/forms/general',
            },
        ],
    ],
    [
        'is',
        [
            {
                market: 'is',
                lang: 'en',
                urlPrefix: '/is/en',
                termsOfUsePath: '/terms-of-use',
                privacyPolicyPath: '/privacy-policy',
                imprintPath: '/imprint',
                inquiryPath: '/forms/general',
            },
        ],
    ],
    [
        'it',
        [
            {
                market: 'it',
                lang: 'it',
                urlPrefix: '/it/it',
                termsOfUsePath: '/condizioni-di-utilizzo',
                privacyPolicyPath: '/privacy',
                imprintPath: '/impressum',
                inquiryPath: '/formulari/regole-generali',
            },
        ],
    ],
    [
        'kg',
        [
            {
                market: 'kg',
                lang: 'ru',
                urlPrefix: '/kg/ru',
                termsOfUsePath: '/uslovija-polzovanija',
                privacyPolicyPath: '/zaschita-dannykh',
                imprintPath: '/vykhodnye-dannye',
                inquiryPath: '/formuljary/obschie-polozhenija',
            },
        ],
    ],
    [
        'kz',
        [
            {
                market: 'kz',
                lang: 'ru',
                urlPrefix: '/kz/ru',
                termsOfUsePath: '/uslovija-polzovanija',
                privacyPolicyPath: '/zaschita-dannykh',
                imprintPath: '/vykhodnye-dannye',
                inquiryPath: '/formuljary/obschie-polozhenija',
            },
        ],
    ],
    [
        'lt',
        [
            {
                market: 'lt',
                lang: 'en',
                urlPrefix: '/lt/en',
                termsOfUsePath: '/terms-of-use',
                privacyPolicyPath: '/privacy-policy',
                imprintPath: '/imprint',
                inquiryPath: '/forms/general',
            },
        ],
    ],
    [
        'lu',
        [
            {
                market: 'lu',
                lang: 'de',
                urlPrefix: '/lu/de',
                termsOfUsePath: '/nutzungsbedingungen',
                privacyPolicyPath: '/datenschutz',
                imprintPath: '/impressum',
                inquiryPath: '/formulare/allgemein',
            },
            {
                market: 'lu',
                lang: 'fr',
                urlPrefix: '/lu/fr',
                termsOfUsePath: '/conditions-dutilisation',
                privacyPolicyPath: '/protection-des-donnees',
                imprintPath: '/informations-legales',
                inquiryPath: '/formulaires/generalites',
            },
        ],
    ],
    [
        'lv',
        [
            {
                market: 'lv',
                lang: 'en',
                urlPrefix: '/lv/en',
                termsOfUsePath: '/terms-of-use',
                privacyPolicyPath: '/privacy-policy',
                imprintPath: '/imprint',
                inquiryPath: '/forms/general',
            },
        ],
    ],
    [
        'me',
        [
            {
                market: 'me',
                lang: 'hr',
                urlPrefix: '/me/hr',
                termsOfUsePath: '/uvjeti-koristenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opcenito',
            },
            {
                market: 'me',
                lang: 'sr',
                urlPrefix: '/me/sr',
                termsOfUsePath: '/uslovi-koriscenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opste-informacije',
            },
        ],
    ],
    [
        'mk',
        [
            {
                market: 'mk',
                lang: 'sr',
                urlPrefix: '/mk/sr',
                termsOfUsePath: '/uslovi-koriscenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opste-informacije',
            },
        ],
    ],
    [
        'nl',
        [
            {
                market: 'nl',
                lang: 'nl',
                urlPrefix: '/nl/nl',
                termsOfUsePath: '/gebruiksvoorwaarden',
                privacyPolicyPath: '/privacybescherming',
                imprintPath: '/impressum',
                inquiryPath: '/formulieren/algemeen',
            },
        ],
    ],
    [
        'no',
        [
            {
                market: 'no',
                lang: 'no',
                urlPrefix: '/no/no',
                termsOfUsePath: '/bruksbetingelser',
                privacyPolicyPath: '/personvern',
                imprintPath: '/impressum',
                inquiryPath: '/skjemaer/generelt',
            },
        ],
    ],
    [
        'pl',
        [
            {
                market: 'pl',
                lang: 'pl',
                urlPrefix: '/pl/pl',
                termsOfUsePath: '/warunki-uzytkowania',
                privacyPolicyPath: '/ochrona-danych',
                imprintPath: '/znak-wydawcy',
                inquiryPath: '/formularze/informacje-ogolne',
            },
        ],
    ],
    [
        'ro',
        [
            {
                market: 'ro',
                lang: 'ro',
                urlPrefix: '/ro/ro',
                termsOfUsePath: '/conditii-de-utilizare',
                privacyPolicyPath: '/protectia-datelor',
                imprintPath: '/mentiuni-legale',
                inquiryPath: '/formulare/informatii-generale',
            },
        ],
    ],
    [
        'rs',
        [
            {
                market: 'rs',
                lang: 'sr',
                urlPrefix: '/rs/sr',
                termsOfUsePath: '/uslovi-koriscenja',
                privacyPolicyPath: '/zastita-podataka',
                imprintPath: '/impresum',
                inquiryPath: '/formulari/opste-informacije',
            },
        ],
    ],
    [
        'se',
        [
            {
                market: 'se',
                lang: 'sv',
                urlPrefix: '/se/sv',
                termsOfUsePath: '/anvaendarvillkor',
                privacyPolicyPath: '/dataskydd',
                imprintPath: '/foeretagsinformation',
                inquiryPath: '/formulaer/allmaent',
            },
        ],
    ],
    [
        'si',
        [
            {
                market: 'si',
                lang: 'sl',
                urlPrefix: '/si/sl',
                termsOfUsePath: '/pogoji-uporabe',
                privacyPolicyPath: '/varstvo-podatkov',
                imprintPath: '/impresum',
                inquiryPath: '/obrazci/na-splosno',
            },
        ],
    ],
    [
        'sk',
        [
            {
                market: 'sk',
                lang: 'sk',
                urlPrefix: '/sk/sk',
                termsOfUsePath: '/podmienky-pouzivania',
                privacyPolicyPath: '/ochrana-osobnych-udajov',
                imprintPath: '/impressum',
                inquiryPath: '/formulare/vseobecne',
            },
        ],
    ],
    [
        'tj',
        [
            {
                market: 'tj',
                lang: 'ru',
                urlPrefix: '/tj/ru',
                termsOfUsePath: '/uslovija-polzovanija',
                privacyPolicyPath: '/zaschita-dannykh',
                imprintPath: '/vykhodnye-dannye',
                inquiryPath: '/formuljary/obschie-polozhenija',
            },
        ],
    ],
    [
        'tm',
        [
            {
                market: 'tm',
                lang: 'ru',
                urlPrefix: '/tm/ru',
                termsOfUsePath: '/uslovija-polzovanija',
                privacyPolicyPath: '/zaschita-dannykh',
                imprintPath: '/vykhodnye-dannye',
                inquiryPath: '/formuljary/obschie-polozhenija',
            },
        ],
    ],
    [
        'ua',
        [
            {
                market: 'ua',
                lang: 'uk',
                urlPrefix: '/ua/uk',
                termsOfUsePath: '/umovy-vykorystannja',
                privacyPolicyPath: '/zakhyst-danykh',
                imprintPath: '/vykhidni-dani',
                inquiryPath: '/formuljary/zagalna-informacija',
            },
        ],
    ],
    [
        'gb',
        [
            {
                market: 'gb', // UK market is represented as 'gb' in our application
                lang: 'en',
                urlPrefix: '/uk/en',
                termsOfUsePath: '/terms-of-use',
                privacyPolicyPath: '/privacy-policy',
                imprintPath: '/imprint',
                inquiryPath: '/forms/general',
            },
        ],
    ],
    [
        'uz',
        [
            {
                market: 'uz',
                lang: 'ru',
                urlPrefix: '/uz/ru',
                termsOfUsePath: '/uslovija-polzovanija',
                privacyPolicyPath: '/zaschita-dannykh',
                imprintPath: '/vykhodnye-dannye',
                inquiryPath: '/formuljary/obschie-polozhenija',
            },
        ],
    ],
]);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const CONTAINEX_PATH_FALLBACK: ContainexPaths = CONTAINEX_PATHS.get('gb')![0]!;
